import Save from './Save.vue'

export default Save
